import React from 'react';
import { motion } from 'framer-motion';
import { FaDove, FaHeart, FaFeather, FaStar } from 'react-icons/fa';

export const FloralDecoration = () => {
  // Responsive sizes for decorations
  const decorationSizes = {
    sm: 'w-48 h-48',
    md: 'w-64 h-64',
    lg: 'w-72 h-72'
  };

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {/* Top left decoration */}
      <motion.div
        initial={{ opacity: 0, rotate: 0, scale: 0.8 }}
        animate={{ 
          opacity: [0.2, 0.4, 0.2],
          rotate: [0, 45],
          scale: [0.8, 1, 0.8]
        }}
        transition={{ 
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        className={`absolute top-0 left-0 ${decorationSizes.sm} md:${decorationSizes.md} lg:${decorationSizes.lg} bg-contain bg-no-repeat mix-blend-multiply filter blur-[1px]`}
        style={{ backgroundImage: "url('/FloralDecoration.png')" }}
      />

      {/* Bottom right decoration */}
      <motion.div
        initial={{ opacity: 0, rotate: 0, scale: 0.8 }}
        animate={{ 
          opacity: [0.2, 0.4, 0.2],
          rotate: [0, -45],
          scale: [0.8, 1, 0.8]
        }}
        transition={{ 
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.5
        }}
        className={`absolute bottom-0 right-0 ${decorationSizes.sm} md:${decorationSizes.md} lg:${decorationSizes.lg} bg-contain bg-no-repeat mix-blend-multiply filter blur-[1px]`}
        style={{ backgroundImage: "url('/FloralDecoration.png')" }}
      />
    </div>
  );
};

export const FloatingElements = () => {
  const elements = [FaHeart, FaDove, FaFeather, FaStar];
  const colors = ['text-pink-300', 'text-pink-200', 'text-rose-300', 'text-amber-200'];
  
  // Responsive number of elements
  const getElementCount = () => {
    if (typeof window === 'undefined') return 10;
    return window.innerWidth < 640 ? 10 : window.innerWidth < 1024 ? 15 : 20;
  };

  return (
    <div className="absolute w-full h-full pointer-events-none">
      {[...Array(getElementCount())].map((_, i) => {
        const ElementComponent = elements[i % elements.length];
        const colorClass = colors[i % colors.length];
        
        return (
          <motion.div
            key={i}
            initial={{
              x: `${Math.random() * 100}vw`,
              y: `${Math.random() * 100}vh`,
              scale: Math.random() * 0.5 + 0.5,
              opacity: Math.random() * 0.4 + 0.1
            }}
            animate={{
              y: [null, '-120vh'],
              x: [null, `${Math.sin(i) * 20}vw`],
              rotate: [0, 360],
              opacity: [null, 0]
            }}
            transition={{
              duration: Math.random() * 20 + 15,
              repeat: Infinity,
              ease: 'linear',
              delay: Math.random() * 5
            }}
            className={`absolute transform-gpu ${colorClass}`}
          >
            <motion.div
              animate={{ 
                scale: [1, 1.2, 1],
                rotate: [0, 180, 360]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              <ElementComponent className={`w-4 h-4 md:w-6 md:h-6`} />
            </motion.div>
          </motion.div>
        );
      })}
    </div>
  );
};
